const styles = {
  form: {
    mb: 4,
    display: 'flex',
  },
  input: {
    backgroundColor: 'white',
    flexGrow: 1,
  },
  button: {
    flexShrink: 0,
    ml: 2,
  }
}

export default styles
